module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBold.1944c8d.ttf";